module.exports = __webpack_public_path__ + "img/social3espanol.02286afd.png";